import request from "@utils/request";

/**
 * 提交评论
 * 
 */
export function postComment(data) {
  return request.post("/comment", data, { login: false });
}
